import ProductItem from '@plugin_productitem/core';

export default ProductItem;
